




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { Widget } from '@xsolla/login-sdk';

import { LoginScope, ResponseType } from '@/constants/xsolla';

@Component
export default class XsollaWidget extends Vue {
  @Prop({ type: String, required: true })
  readonly projectId!: string;

  @Prop({ type: Number })
  readonly clientId?: number;

  @Prop({ type: String })
  readonly preferredLocale?: string;

  @Prop({ type: String })
  readonly callbackUrl?: string;

  @Prop({ type: String })
  readonly redirectUri?: string;

  @Prop({ type: String })
  readonly state?: string;

  @Prop({ type: String })
  readonly payload?: string;

  @Prop({ type: String, default: LoginScope.OFFLINE })
  readonly scope!: string;

  @Prop({ type: String, default: ResponseType.CODE })
  readonly responseType!: string;

  @Prop({ type: Boolean })
  readonly lazy!: boolean;

  @Prop({ type: String })
  readonly settingsJsonUrl?: string;

  @Prop({ type: String })
  readonly socialsJsonUrl?: string;

  xl!: Widget;

  mount = false;

  beforeMount() {
    this.xl = new Widget({
      projectId: this.projectId,
      clientId: this.clientId,
      callbackUrl: this.callbackUrl,
      redirectUri: this.redirectUri,
      scope: this.scope,
      responseType: this.responseType,
      state: this.state,
      payload: this.payload,
      preferredLocale: this.preferredLocale,
      settingsJSON: this.settingsJsonUrl,
      socialsJSON: this.socialsJsonUrl,
      theme: {
        scene: {
          color: 'transparent',
        },
      },
    } as never);
  }

  mounted() {
    this.xl.on(this.xl.events.Close, this.handleClose);

    if (this.lazy) {
      return;
    }

    this.mountWidget();
  }

  beforeDestroy() {
    this.xl.off(this.xl.events.Close, this.handleClose);
  }

  @Watch('preferredLocale')
  localeChanged(locale: string) {
    this.xl.setLocale(locale);
  }

  open() {
    if (!this.mount) {
      this.mountWidget();
    }

    this.xl.open();
  }

  close() {
    this.xl.close();
  }

  mountWidget() {
    this.xl.mount(this.$el.id);

    this.mount = true;
  }

  handleClose() {
    this.close();

    this.$emit('close');
  }
}
